"use client";

import { useEffect } from "react";

export function useClickOutsideHandler(
    wrapperRef: React.MutableRefObject<HTMLDivElement | null>,
    isOpened: boolean,
    setOpened: (isOpened: boolean) => void,
) {
    function handleClickOutside(event: MouseEvent | KeyboardEvent) {
        const isClickedOutside = wrapperRef.current && !wrapperRef.current.contains(event.target as HTMLDivElement);
        if (isOpened && isClickedOutside) {
            setOpened(false);
        }
    }

    const handleEscapePress = (event: KeyboardEvent) => {
        if (event.key === "Escape") {
            return handleClickOutside(event);
        }
    };

    useEffect(() => {
        if (typeof window !== "undefined" && typeof document !== "undefined") {
            document.addEventListener("click", handleClickOutside, true);
            document.addEventListener("keydown", handleEscapePress);
            return () => {
                document.removeEventListener("click", handleClickOutside, true);
                document.removeEventListener("keydown", handleEscapePress);
            };
        }

        return undefined;
    });
}
